const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  laptop: '960px',
  xlaptop: '1440px',
}

export const { mobile, tablet, laptop, xlaptop } = breakpoints
